export default "__VITE_ASSET__xD0Xe_gC__"